export default __webpack_public_path__ + "static/media/4.2a0c7788.jpg";